/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { SessionParams } from '../context/SessionContext';
import {
  isInstantJoinTechnicallySupported,
  isMobileJoinTechnicallySupported,
  isNativeEndpointTechnicallySupported,
} from './ProductCompatibilityService';
import { navigateTo } from './NavigatorService';
import { buildInstantJoinUrl } from './UrlService';
import { sendJoinLaunchEvent } from '../lib/telemetry';
import { ThemeType } from './IndexPageReaderService';

export const redirectIfSupported = (params: SessionParams): void => {
  const { meetingId, meetingInfo, sessionTrackingId } = params;
  if (
    (isNativeEndpointTechnicallySupported &&
      !meetingInfo.sessionOptions.nativeEndpointDisabled) ||
    isMobileJoinTechnicallySupported
  ) {
    return;
  }
  if (isInstantJoinTechnicallySupported) {
    // Cannot use React Hook "useSendJoinLaunchTelemetry" here
    sendJoinLaunchEvent(
      params.telemetryService,
      meetingId,
      sessionTrackingId,
      'triggerJoinPageWeb',
      'auto_web_join',
      meetingInfo.build,
      ThemeType.GoToMeetingTheme,
      0
    );
    navigateTo(buildInstantJoinUrl(meetingId, sessionTrackingId));
  }
};
